import React from "react";
import { useDispatch, useSelector } from "react-redux";

import PropTypes from "prop-types";

import {
  Dialog,
  DialogTitle,
  DialogContent,
  Box,
  Tabs,
  Tab,
  Grid,
  Typography,
  makeStyles
} from "@material-ui/core";

import { MENU_INFORMACION_EXPEDIENTES, MENU_MESA_ENTRADA, MENU_TIPO_EXPEDIENTE } from "../../../utils/constants";
import { useState } from "react";
import { InformacionComprobante } from "../MesaEntradaGestion/InformacionComprobante";
import { cleanDocumentacionMesaEntrada, getDocumentacionComprobante } from "../../../actions/mesaEntrada/documentacionMesaEntradaActions";
import { DocumentacionComprobante } from "./Documentacion/DocumentacionComprobante";

const useStyles = makeStyles((theme) => ({
    column:{
        textAlign: "center",
        display: "flex",
        flexDirection: "column"
    },
    center:{
        textAlign: "center",
    },
    textObservaciones:{ 
        width:'100%',
        border: '1px solid #ccc',
        borderRadius: '.5em',
        textAlign: 'left',
        padding: '1em',
        wordBreak: 'break-word'
    },
}));

function TabPanel(props) {
    const { children, value, index, ...other } = props;

    return (
        <div
            role="tabpanel"
            hidden={value !== index}
            id={`full-width-tabpanel-${index}`}
            aria-labelledby={`full-width-tab-${index}`}
            name={index}
            {...other}
        >
            {value === index && <Box p={2}>{children}</Box>}
        </div>
    );
}
  
TabPanel.propTypes = {
    children: PropTypes.node,
    index: PropTypes.any.isRequired,
    value: PropTypes.any.isRequired,
};

function a11yProps(index) {
    return {
        id: `full-width-tab-${index}`,
        "aria-controls": `full-width-tabpanel-${index}`,
    };
}

export const ModalInformacionExpediente = (props) => {
    const classes = useStyles();
    const dispatch = useDispatch();
    const { open, expediente, tipoComprobanteDocumento } = props;
    const { activeBreadcrumb, destinos, recepcionMenu } = useSelector(state => state.mesaEntrada);

    const menuPrestadorGestion = activeBreadcrumb === MENU_MESA_ENTRADA.GESTION_COMPROBANTES_PRESTADORES || recepcionMenu === MENU_TIPO_EXPEDIENTE.PRESTADOR;
    const menuDocumentoGestion = activeBreadcrumb === MENU_MESA_ENTRADA.GESTION_COMPROBANTES_DOCUMENTO || recepcionMenu === MENU_TIPO_EXPEDIENTE.DOCUMENTO;
    
    const [selectedTab, setSelectedTab] = useState(props.onComprobante 
        ? (menuPrestadorGestion ? MENU_INFORMACION_EXPEDIENTES.DATOS_COMPROBANTE_PRESTADORES : MENU_INFORMACION_EXPEDIENTES.DATOS_COMPROBANTE_DOCUMENTO) 
        : MENU_INFORMACION_EXPEDIENTES.DATOS_TRAMITE
    );

    return (
        <Dialog
            fullWidth
            maxWidth="md"
            open={open}
            onClose={props.closeModalHandler}
        >
        <DialogTitle>Información del Comprobante - IdComprobante: {expediente?.idExpediente.toString()} - IdComprobante SV: {expediente?.idExpedientes.toString()}</DialogTitle>
        <DialogContent>
            <Tabs
                value={selectedTab}
                onChange={(event, newValue) => {
                    if(newValue === MENU_INFORMACION_EXPEDIENTES.DOCUMENTACION)
                        dispatch(getDocumentacionComprobante(expediente?.idExpediente));
                    else
                        dispatch(cleanDocumentacionMesaEntrada());
                    setSelectedTab(newValue)
                }}
                indicatorColor="primary"
                textColor="primary"
                variant="fullWidth"
            >
                <Tab
                    value={MENU_INFORMACION_EXPEDIENTES.DATOS_TRAMITE}
                    label="Trámite"
                    {...a11yProps(MENU_INFORMACION_EXPEDIENTES.DATOS_TRAMITE)}
                />
                {menuPrestadorGestion &&
                    <Tab
                        value={MENU_INFORMACION_EXPEDIENTES.DATOS_COMPROBANTE_PRESTADORES}
                        label="Comprobante"
                        {...a11yProps(MENU_INFORMACION_EXPEDIENTES.DATOS_COMPROBANTE_PRESTADORES)}
                    />
                }
                {menuDocumentoGestion &&
                    <Tab
                        value={MENU_INFORMACION_EXPEDIENTES.DATOS_COMPROBANTE_DOCUMENTO}
                        label="Comprobante"
                        {...a11yProps(MENU_INFORMACION_EXPEDIENTES.DATOS_COMPROBANTE_DOCUMENTO)}
                    />
                }
                <Tab
                    value={MENU_INFORMACION_EXPEDIENTES.DOCUMENTACION}
                    label="Documentacion"
                    {...a11yProps(MENU_INFORMACION_EXPEDIENTES.DOCUMENTACION)}
                />
                <Tab
                    value={MENU_INFORMACION_EXPEDIENTES.DATOS_CARGA}
                    label="Carga"
                    {...a11yProps(MENU_INFORMACION_EXPEDIENTES.DATOS_CARGA)}
                />
            </Tabs>
            <TabPanel
                value={selectedTab}
                index={MENU_INFORMACION_EXPEDIENTES.DATOS_TRAMITE}
            >
                <Grid 
                    container
                    spacing={1}
                    justify="center"
                >
                    <Grid item xs={5} className={classes.column}>
                        <Typography variant="subtitle1" style={{margin: "5px"}}>
                            Tramite 
                        </Typography>
                        <Typography variant="button" style={{margin: "5px"}}>
                            {expediente.descripcionTramite}
                        </Typography>
                    </Grid>
                    <Grid item xs={5} className={classes.column}>
                    <Typography variant="subtitle1" style={{margin: "5px"}}>
                            Destino 
                        </Typography>
                        <Typography variant="button" style={{margin: "5px"}}>
                            {destinos.find(destino => destino?.id === expediente.idDestino)?.descripcion}
                        </Typography>
                    </Grid>
                </Grid>
            </TabPanel>
            <TabPanel
                value={selectedTab}
                index={MENU_INFORMACION_EXPEDIENTES.DATOS_COMPROBANTE_PRESTADORES}
            >
                <InformacionComprobante expediente={expediente}
                    tab={selectedTab}
                    classes={classes}
                />
            </TabPanel>
            <TabPanel
                value={selectedTab}
                index={MENU_INFORMACION_EXPEDIENTES.DATOS_COMPROBANTE_DOCUMENTO}
            >
                <InformacionComprobante expediente={expediente}
                    tipoComprobanteDocumento={tipoComprobanteDocumento}
                    tab={selectedTab}
                    classes={classes}
                />
            </TabPanel>
            <TabPanel
                value={selectedTab}
                index={MENU_INFORMACION_EXPEDIENTES.DOCUMENTACION}
            >
                <DocumentacionComprobante idExpediente={expediente.idExpediente} 
                    menuPrestadorGestion={menuPrestadorGestion}
                    ospeDirecto={expediente.fechaAltaOspeDirecto ?? false}
                    disabled
                />
            </TabPanel>
            <TabPanel
                value={selectedTab}
                index={MENU_INFORMACION_EXPEDIENTES.DATOS_CARGA}
            >
                <Grid 
                    container
                    spacing={1}
                    justify="center"
                >
                    <Grid item xs={5} className={classes.column}>
                        <Typography variant="subtitle1" style={{margin: "5px"}}>
                            Fecha Carga 
                        </Typography>
                        <Typography variant="button" style={{margin: "5px"}}>
                            {expediente.fechaCarga.replace("T", " - ")}
                        </Typography>
                    </Grid>
                    <Grid item xs={5} className={classes.column}>
                    <Typography variant="subtitle1" style={{margin: "5px"}}>
                            Usuario 
                        </Typography>
                        <Typography variant="button" style={{margin: "5px"}}>
                            {expediente.nombreUsuarioCarga}
                        </Typography>
                    </Grid>
                </Grid>
            </TabPanel>
        </DialogContent>
        </Dialog>
    );
};
